import{WeChatLinkMap}from"../manager/WeChatConst";



let weChatChitLink:WeChatLinkMap=null;

export default function WeChatChitConfigs(){
    if(!weChatChitLink){
        weChatChitLink={
            "4000": {
                people: "母妃",
                chats: [
                    {id:"0",peopleId:"母妃",chooses:[{chat:"皇儿",param:{"nextId":1}}]},
                    {id:"1",peopleId:"母妃",chooses:[{chat:"你之前在宫中的死对头，最近开始变得异常活跃",param:{"nextId":2}}]},
                    {id:"2",peopleId:"母妃",chooses:[{chat:"担心他们会对你不利",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"母后放心，孩儿隐藏在民间",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"那般奸臣一时半会也找不到我",param:{"nextId":5}}]},
                    {id:"5",peopleId:"母妃",chooses:[{chat:"你这孩子，就是担心你太轻敌",param:{"nextId":6}}]},
                    {id:"6",peopleId:"自己",chooses:[{chat:"让母后担心了，母后在宫中可还好",param:{"nextId":7}}]},
                    {id:"7",peopleId:"母妃",chooses:[{chat:"母后虽被禁足，但你父皇还是安排人细心照料",param:{"nextId":8}}]},
                    {id:"8",peopleId:"母妃",chooses:[{chat:"倒是你，民间鱼龙混杂，你要小心行事，不可轻信于人",param:{"nextId":9}}]},
                    {id:"9",peopleId:"自己",chooses:[{chat:"孩儿谨记，终于一日孩儿定会来解救母后",param:{"WeChatLink":["1", "2"]}}]},
                ]
            },      
            "4001": {
                people: "江南好友",
                chats: [
                    {id:"0",peopleId:"江南好友",chooses:[{chat:"兄弟，现在在哪里快活呀",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"我现在在幽州城，穷得都快吃不起饭了",param:{"nextId":2}}]},
                    {id:"2",peopleId:"江南好友",chooses:[{chat:"什么情况，缺钱花吗",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"家里发生了变故，一言难尽呀",param:{"nextId":4}}]},
                    {id:"4",peopleId:"江南好友",chooses:[{chat:"那我就当没事咯，给你寄一些钱过去，你先用着",param:{"nextId":5}}]},
                    {id:"5",peopleId:"江南好友",chooses:[{chat:" ",param:{goods: [{coin:2000}],recvGoodsAd: true,"nextId":6}}]},
                    {id:"6",peopleId:"江南好友",chooses:[{chat:"最近百乐门出了刮刮乐，比较容易中奖，可以去试试",param:{"nextId":7}}]},
                    {id:"7",peopleId:"自己",chooses:[{chat:"谢了兄弟，等我赚了钱还你",param:{"WeChatLink":"3"}}]},
                ]
            },  
            "4002": {
                people: "皇妹",
                chats: [
                    {id:"0",peopleId:"皇妹",chooses:[{chat:"哥哥，你在民间还好吗",param:{"nextId":1}}]},
                    {id:"1",peopleId:"皇妹",chooses:[{chat:"我去找父皇替你求情，还被父皇责罚啦",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"傻丫头，这个节骨眼上找父皇，父皇肯定龙颜大怒",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"你替我照顾一下母后，我就知足啦",param:{"nextId":4}}]},
                    {id:"4",peopleId:"皇妹",chooses:[{chat:"我不要，我又不会照顾人",param:{"nextId":5}}]},
                    {id:"5",peopleId:"皇妹",chooses:[{chat:"我决定来找哥哥，不论平穷富贵我都愿意陪着哥哥",param:{"nextId":6}}]},
                    {id:"6",peopleId:"皇妹",chooses:[{chat:"我现在就出发，哥哥等我",param:{"nextId":7}}]},
                    {id:"7",peopleId:"自己",chooses:[{chat:"傻丫头，不要冲动啊",param:{"WeChatLink":"4"}}]},
                ]
            },
            "4003": {
                people: "神秘人",
                chats: [
                    {id:"0",peopleId:"神秘人",chooses:[{chat:"这位少侠，我是慕名而来，如有打扰还请见谅",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"你是谁，有什么事吗？",param:{"nextId":2}}]},
                    {id:"2",peopleId:"神秘人",chooses:[{chat:"我是城中百晓生，城中大小事情都可以问我，只需要一点点打赏即可",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"有事再说吧，我现在没时间",param:{"nextId":4}}]},
                    {id:"4",peopleId:"神秘人",chooses:[{chat:"少侠可是缺钱用，卖东西可以去当铺，那里出价会更高",param:{"nextId":5}}]},      
                    {id:"5",peopleId:"自己",chooses:[{chat:"你到底是谁",param:{"nextId":6}}]},           
                    {id:"6",peopleId:"神秘人",chooses:[{chat:"我刚刚已经说过了，城中大小事情，我都知道",param:{"nextId":7}}]},    
                    {id:"7",peopleId:"自己",chooses:[{chat:"行，有需要我会再找你",param:{"WeChatLink":"5"}}]},
                ]
            },
            "4004": {
                people: "皇妹",
                chats: [
                    {id:"0",peopleId:"皇妹",chooses:[{chat:"哥哥，我已经快到幽州城了",param:{"nextId":1}}]},
                    {id:"1",peopleId:"皇妹",chooses:[{chat:"很想哥哥，真希望能再快一点",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"傻丫头，宫中衣食无忧，来找我是要吃苦的",param:{"nextId":3}}]},
                    {id:"3",peopleId:"皇妹",chooses:[{chat:"没关系，我不怕吃苦",param:{"nextId":4}}]},
                    {id:"4",peopleId:"皇妹",chooses:[{chat:"跟哥哥在一起是皇妹最大的心愿",param:{"nextId":5}}]},
                    {id:"5",peopleId:"自己",chooses:[{chat:"傻丫头，路上注意安全，我在城南等你",param:{"nextId":6}}]},
                    {id:"6",peopleId:"皇妹",chooses:[{chat:"嘿嘿，哥哥最好了，马上就能见到哥哥啦~",param:{"WeChatLink":"6"}}]},
                ]
            },
            "4005": {
                people: "国舅",
                chats: [
                    {id:"0",peopleId:"国舅",chooses:[{chat:"殿下，终于找到殿下的下落，老臣护驾来迟，请殿下恕罪",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"国舅无需自责，是我自己隐藏了行踪",param:{"nextId":2}}]},                    
                    {id:"2",peopleId:"国舅",chooses:[{chat:"殿下，据探子来报，敌国势力蠢蠢欲动，朝堂还有他们的内应",param:{"nextId":3}}]},
                    {id:"3",peopleId:"国舅",chooses:[{chat:"许多城池守将听说殿下的事情，纷纷赶往幽州城准备投奔殿下",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"胡闹，城池无人驻守岂不是拱手让给敌人",param:{"nextId":5}}]},
                    {id:"5",peopleId:"国舅",chooses:[{chat:"殿下放心，前线守军奋勇抵抗，暂时还不会丢城",param:{"nextId":6}}]},
                    {id:"6",peopleId:"国舅",chooses:[{chat:"殿下需尽快招募武将，在社稷图镇守城池",param:{"nextId":7}}]},
                    {id:"7",peopleId:"自己",chooses:[{chat:"我知道了",param:{"WeChatLink":"7"}}]},               
                ]
            },
            "4006": {
                people: "母妃",
                chats: [
                    {id:"0",peopleId:"母妃",chooses:[{chat:"皇儿，你妹妹上次找你父皇替你求情，被你父皇禁足",param:{"nextId":1}}]},
                    {id:"1",peopleId:"母妃",chooses:[{chat:"听说她已经逃出皇家别院要去找你",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"孩儿知道了，皇妹跟孩儿写过信了，很快就到我这里",param:{"nextId":3}}]},
                    {id:"3",peopleId:"母妃",chooses:[{chat:"这孩子真不听话",param:{"nextId":4}}]},
                    {id:"4",peopleId:"母妃",chooses:[{chat:"你尽快接到你皇妹，照顾好她",param:{"nextId":5}}]},
                    {id:"5",peopleId:"母妃",chooses:[{chat:"宫中再有情况发生，母后会再联系你",param:{"nextId":6}}]},
                    {id:"6",peopleId:"自己",chooses:[{chat:"孩儿谨记，定会照顾妥帖",param:{addDelayEvent: {id: 1, delay: 1}}}]},              
                ]
            },
            "4007": {
                people: "神秘人",
                chats: [
                    {id:"0",peopleId:"神秘人",chooses:[{chat:"少侠，去过当铺了吗？",param:{"nextId":1}}]},
                    {id:"1",peopleId:"神秘人",chooses:[{chat:"听说当铺的老板娘还是个单身",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"你想说什么",param:{"nextId":3}}]},    
                    {id:"3",peopleId:"神秘人",chooses:[{chat:"别生气，我是来送情报的",param:{"nextId":4}}]},      
                    {id:"4",peopleId:"神秘人",chooses:[{chat:"不想当东西，又不去玩两把，可以去招工那混口饭吃",param:{"nextId":5}}]},      
                    {id:"5",peopleId:"自己",chooses:[{chat:"知道了，你的话太多了",param:{"WeChatLink":"8"}}]},      
                ]
            },
            "4008": {
                people: "国舅",
                chats: [
                    {id:"0",peopleId:"国舅",chooses:[{chat:"殿下，老臣属实无奈迫不得已再次找到殿下",param:{"nextId":1}}]},
                    {id:"1",peopleId:"国舅",chooses:[{chat:"朝中那些贪官，弃百姓于不顾，皇上还被蒙在鼓里，熟不知北方灾情",param:{"nextId":2}}]},
                    {id:"2",peopleId:"国舅",chooses:[{chat:"现在大量灾民朝幽州方向逃荒，需筹得二十万石粮食方可制止灾民涌向皇城呀",param:{"nextId":3}}]},
                    {id:"3",peopleId:"国舅",chooses:[{chat:"此事若能成，陛下定会对殿下刮目相看，回朝之日可待呀",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"这个任务，我接下了，多谢国舅爷提醒",param:{"nextId":5}},{chat:"我也无能为力，这么多灾民，仅凭我一人之力怎可扭转",param:{"nextId":11}}]},
                    {id:"5",peopleId:"国舅",chooses:[{chat:"殿下，不愧为皇家子弟，如此困境仍心系百姓，只不过这可不是一笔小数呀，折合铜币100万呀",param:{"nextId":6}}]},
                    {id:"6",peopleId:"自己",chooses:[{chat:"国舅爷不必担心，我自有办法，不知道多久需要用到这笔赈灾款",param:{"nextId":7}}]},
                    {id:"7",peopleId:"国舅",chooses:[{chat:"处置灾民也不是一朝一夕就能完成的，需分20日，每日5万铜币即可",param:{"nextId":8}}]},
                    {id:"8",peopleId:"自己",chooses:[{chat:"国舅放心，明日开始每日5万铜币送上，还劳烦国舅找人处理好此事",param:{"nextId":9}}]},
                    {id:"9",peopleId:"国舅",chooses:[{chat:"多谢殿下，此事若成，我必面圣如实将此事禀报",param:{"nextId":10}}]},
                    {id:"10",peopleId:"自己",chooses:[{chat:"有劳国舅啦",param:{coin:1000000,"accountInfo":{title:"需缴款",desc:"每日需缴@！共计@ 总需缴@",paramsArray:["5万","20日","100万"],totalFee:1000000,needPayDays:20}}}]},
                    {id:"11",peopleId:"国舅",chooses:[{chat:"殿下此事是殿下翻身的绝佳机会，不可轻言放弃呀",param:{"nextId":12}}]},
                    {id:"12",peopleId:"国舅",chooses:[{chat:"殿下曾在朝中的功绩，论哪位皇子能出其右，老臣也支持于殿下",param:{"nextId":13}}]},
                    {id:"13",peopleId:"自己",chooses:[{chat:"我知国舅爷一直支持我，只是此一时彼一时，我也凑不出这么多钱财",param:{"nextId":14}}]},
                    {id:"14",peopleId:"国舅",chooses:[{chat:"老臣知道了，老臣会再另寻他法，殿下保重",param:{"nextId":15}}]},
                    {id:"15",peopleId:"自己",chooses:[{chat:"国舅爷保重",param:{}}]},                
                ]
            },
            "4009": {
                people: "老妇人的孙女",
                chats: [
                    {id:"0",peopleId:"老妇人的孙女",chooses:[{chat:"敢不敢跟我玩个游戏",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"为什么要跟你玩游戏",param:{"nextId":2}},{chat:"我对你没什么兴趣",param:{"nextId":4}}]},
                    {id:"2",peopleId:"老妇人的孙女",chooses:[{chat:"我就知道你不敢，说那么多有什么用",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"激将法是吧，我不吃这一套",param:{"nextId":4}}]},
                    {id:"4",peopleId:"老妇人的孙女",chooses:[{chat:"你不是对我不感兴趣吗？玩个游戏，你怕啥",param:{"nextId":5}}]},
                    {id:"5",peopleId:"自己",chooses:[{chat:"放马过来吧",param:{"nextId":6}}]},
                    {id:"6",peopleId:"老妇人的孙女",chooses:[{chat:"脑筋急转弯，第1题：狼来了，打一种中水果是什么",param:{"nextId":7}}]},
                    {id:"7",peopleId:"自己",chooses:[{chat:"蓝莓（狼没）",param:{"nextId":8}},{chat:"杨梅（羊没）",param:{"nextId":9}}]},
                    {id:"8",peopleId:"老妇人的孙女",chooses:[{chat:"真笨，是杨梅呀（羊没）呀",param:{"nextId":9}}]},
                    {id:"9",peopleId:"老妇人的孙女",chooses:[{chat:"那羊来了呢，是什么",param:{"nextId":10}}]},
                    {id:"10",peopleId:"自己",chooses:[{chat:"草莓（草没）",param:{"nextId":12}},{chat:"不知道",param:{"nextId":11}}]},
                    {id:"11",peopleId:"老妇人的孙女",chooses:[{chat:"是草莓呀，真笨",param:{"nextId":12}}]},
                    {id:"12",peopleId:"老妇人的孙女",chooses:[{chat:"那我来了呢",param:{"nextId":13}}]},
                    {id:"13",peopleId:"自己",chooses:[{chat:".....我怎么知道",param:{"nextId":14}}]},
                    {id:"14",peopleId:"老妇人的孙女",chooses:[{chat:"算你倒霉呀",param:{"nextId":15}}]},        
                    {id:"15",peopleId:"老妇人的孙女",chooses:[{chat:"臭弟弟，我下次再来找你",param:{"WeChatLink":"32"}}]},            
                ]
            },
            "4010": {
                people: "老妇人的孙女",
                chats: [
                    {id:"0",peopleId:"老妇人的孙女",chooses:[{chat:"嘿嘿，我又来啦~",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"你到底想干嘛",param:{"nextId":2}},{chat:"大小姐，别闹了行不行",param:{"nextId":3}}]},
                    {id:"2",peopleId:"老妇人的孙女",chooses:[{chat:"想撩你呀~",param:{"nextId":3}}]},
                    {id:"3",peopleId:"老妇人的孙女",chooses:[{chat:"难道我不好看吗？不可爱吗？",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"可爱可爱",param:{"nextId":6}},{chat:"好看好看",param:{"nextId":5}}]},
                    {id:"5",peopleId:"老妇人的孙女",chooses:[{chat:"那你多看两眼，以后没得看了",param:{"nextId":6}}]},
                    {id:"6",peopleId:"老妇人的孙女",chooses:[{chat:"我做腻了可爱的女孩子",param:{"nextId":7}}]},
                    {id:"7",peopleId:"自己",chooses:[{chat:"那你想做什么",param:{"nextId":8}}]},
                    {id:"8",peopleId:"老妇人的孙女",chooses:[{chat:"想做你太太",param:{"nextId":9}}]},
                    {id:"9",peopleId:"自己",chooses:[{chat:"......",param:{"nextId":10}}]},
                    {id:"10",peopleId:"老妇人的孙女",chooses:[{chat:"哈哈~你单身多久了呀？",param:{"nextId":11}}]},
                    {id:"11",peopleId:"自己",chooses:[{chat:"要你管",param:{"nextId":13}},{chat:"很久了",param:{"nextId":12}}]},
                    {id:"12",peopleId:"老妇人的孙女",chooses:[{chat:"对不起，让你久等啦",param:{"nextId":13}}]},
                    {id:"13",peopleId:"老妇人的孙女",chooses:[{chat:"本小姐看上的，就是我的",param:{"nextId":14}}]},
                    {id:"14",peopleId:"老妇人的孙女",chooses:[{chat:" ",param:{goods: [{coin:10000}],recvGoodsAd: true,"nextId":15}}]},
                    {id:"15",peopleId:"老妇人的孙女",chooses:[{chat:"对自己好一点，我下次再来找你",param:{}}]},
                ]
            },
	    "4011": {
                people: "竹清清",
                chats: [
                    {id:"0",peopleId:"竹清清",chooses:[{chat:"你什么时候来娶我呀~我不会成弃妇了吧~",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"怎么会呢",param:{"nextId":2}},{chat:"再忍耐一下",param:{"nextId":3}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"我已经安排管家，加急处理了",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"快了，我也比较着急，你爹爹都要提刀来削我了",param:{"nextId":4}}]},
                    {id:"4",peopleId:"竹清清",chooses:[{chat:"那你有没有想我呀，都不来看看我",param:{"nextId":6}},{chat:"好看好看",param:{"nextId":5}}]},
                    {id:"5",peopleId:"自己",chooses:[{chat:"怎么不想，一日不见如隔三秋",param:{"nextId":6}}]},
                    {id:"6",peopleId:"竹清清",chooses:[{chat:"好嘛~好嘛~",param:{"nextId":7}}]},
                    {id:"7",peopleId:"竹清清",chooses:[{chat:"那我就再忍忍吧",param:{}}]},
                ]
            },
            "4012": {
                people: "竹清清",
                chats: [
                    {id:"0",peopleId:"竹清清",chooses:[{chat:"你为什么走了，有什么问题你跟我说嘛",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"你知道你父亲提的彩礼是多少吗？",param:{"nextId":2}}]},
                    {id:"2",peopleId:"竹清清",chooses:[{chat:"我知道呀，彩礼5个亿外加一个神农鼎",param:{"nextId":3}}]},
                    {id:"3",peopleId:"竹清清",chooses:[{chat:"在我们这边，这个彩礼已经是很好了",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"你要不要听听你自己在说些什么",param:{"nextId":5}}]},
                    {id:"5",peopleId:"竹清清",chooses:[{chat:"你不要嫌弃嘛，我知道我爹爹提的彩礼有点过分",param:{"nextId":6}}]},
                    {id:"6",peopleId:"竹清清",chooses:[{chat:"我们家反双倍彩礼，我爹爹怕你会有压力",param:{"nextId":7}}]},
                    {id:"7",peopleId:"自己",chooses:[{chat:"你爹看不起谁呢",param:{"nextId":8}},{chat:"反双倍彩礼呀",param:{"nextId":9}}]},
                    {id:"8",peopleId:"自己",chooses:[{chat:"娶你这么漂亮女人，就这么点彩礼",param:{"nextId":9}}]},
                    {id:"9",peopleId:"自己",chooses:[{chat:"必须要加彩礼，不然我接受不了",param:{"nextId":10}}]},
                    {id:"10",peopleId:"竹清清",chooses:[{chat:"好嘛~好嘛~，我再跟爹爹商量商量",param:{"nextId":11}}]},
                    {id:"11",peopleId:"竹清清",chooses:[{chat:"还有那个神农鼎，可以在集市找一个老者，用五彩灵石炼制合成呢",param:{"nextId":12}}]},
                    {id:"12",peopleId:"自己",chooses:[{chat:"你是在教我做事吗？",param:{"nextId":13}}]},
                    {id:"13",peopleId:"竹清清",chooses:[{chat:"我错了，我会乖乖等你来娶我的",param:{"nextId":14}}]},
                    {id:"14",peopleId:"自己",chooses:[{chat:"这才对嘛，要记得每天想我",param:{"nextId":15}}]},
                    {id:"15",peopleId:"竹清清",chooses:[{chat:"好~",param:{}}]},
                ]
            },
            "4013": {
                people: "老妇人的孙女",
                chats: [
                    {id:"0",peopleId:"老妇人的孙女",chooses:[{chat:"嘿嘿，我又来啦~",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"这次让我先说",param:{"nextId":2}}]},
                    {id:"2",peopleId:"老妇人的孙女",chooses:[{chat:"你说你说~",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"我要娶你",param:{"nextId":4}}]},
                    {id:"4",peopleId:"老妇人的孙女",chooses:[{chat:"...这是什么情况呀",param:{"nextId":5}}]},
                    {id:"5",peopleId:"老妇人的孙女",chooses:[{chat:"太突然了，我还没打算嫁人呢",param:{"nextId":6}}]},
                    {id:"6",peopleId:"自己",chooses:[{chat:"那算了，咱们以后不要联系了",param:{"nextId":7}}]},
                    {id:"7",peopleId:"老妇人的孙女",chooses:[{chat:"你突然来个回马枪，我都没反应过来",param:{"nextId":8}}]},
                    {id:"8",peopleId:"自己",chooses:[{chat:"不是你撩我的时候了是吗?",param:{"nextId":9}}]},
                    {id:"9",peopleId:"自己",chooses:[{chat:"女人的嘴，骗人的鬼",param:{"nextId":10}}]},
                    {id:"10",peopleId:"老妇人的孙女",chooses:[{chat:"我叶心怡说一不二，你等着，我现在就来找你",param:{addDelayEvent: {id: 41, delay: 0}, addRecordPoint: '4013Finish'}}]},
                ]
            },
            "5001": {//来过1次当铺后触发
                people: "当铺掌柜",
                chats: [
                    {id:"0",peopleId:"当铺掌柜",chooses:[{chat:"公子，还记得我吗",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"当然记得",param:{"nextId":2}}]},
                    {id:"2",peopleId:"当铺掌柜",chooses:[{chat:"公子好记性，不知道最近是否有店里坐坐",param:{"nextId":3}}]},
                    {id:"3",peopleId:"当铺掌柜",chooses:[{chat:"不做生意，只聊天也可以",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"多谢老板娘抬举，我有空会就来",param:{"nextId":5}}]},
                    {id:"5",peopleId:"当铺掌柜",chooses:[{chat:"我等你哟~",param:{"WeChatLink":"15"}}]},
                ]
            },
            "5002": {//有1天没有来当铺
                people: "当铺掌柜",
                chats: [
                    {id:"0",peopleId:"当铺掌柜",chooses:[{chat:"你最近都忙些什么呢？",param:{"nextId":1}}]},
                    {id:"1",peopleId:"当铺掌柜",chooses:[{chat:"都不来店里了，是不是还有人出价比我高",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"最近一直在忙",param:{"nextId":3}}]},
                    {id:"3",peopleId:"当铺掌柜",chooses:[{chat:"那好吧，再忙也要照顾好自己",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"这个我还是会的",param:{}}]},
               ]
            },
            "5003": {//来过1次百乐门后触发
                people: "百乐门掌柜",
                chats: [
                    {id:"0",peopleId:"百乐门掌柜",chooses:[{chat:"公子，怎么不来玩了呀，是不是我招待不好呀",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"不是不是，最近忙着赚钱，抽不开身",param:{"nextId":2}}]},
                    {id:"2",peopleId:"百乐门掌柜",chooses:[{chat:"我们这里也可以赚钱呀，没事多来玩",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"好，有时间一定去",param:{"WeChatLink":"16"}}]},         
                ]
            },
            "5004": {//有1天没有来百乐门后触发
                people: "百乐门掌柜",
                chats: [
                    {id:"0",peopleId:"百乐门掌柜",chooses:[{chat:"公子是不是忘了我啦",param:{"nextId":1}}]},
                    {id:"1",peopleId:"百乐门掌柜",chooses:[{chat:"都好久没有来这里玩啦",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"我也不能成天去玩",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"我还有更重要的事情要做",param:{"nextId":4}}]},      
                    {id:"4",peopleId:"百乐门掌柜",chooses:[{chat:"好嘛，那你要记得来看我",param:{"nextId":5}}]},   
                    {id:"5",peopleId:"自己",chooses:[{chat:"会的",param:{}}]},      
                ]
            },
            "5005": {//第1次成功搬砖1次以后
                people: "包工头",
                chats: [
                    {id:"0",peopleId:"包工头",chooses:[{chat:"小伙子，干的不错，没有看错人",param:{"nextId":1}}]},
                    {id:"1",peopleId:"包工头",chooses:[{chat:"以后来不用跟我打招呼了，工钱不会拖欠你的",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"多谢信任",param:{"nextId":3}}]},
                    {id:"3",peopleId:"包工头",chooses:[{chat:"哈哈，这都是你自己换来的，不用谢",param:{"nextId":4}}]},      
                    {id:"4",peopleId:"包工头",chooses:[{chat:"这是给你的",param:{"nextId":5}}]},  
                    {id:"5",peopleId:"包工头",chooses:[{chat:" ",param:{goods: [{coin:500}],recvGoodsAd: true,"nextId":6}}]}, 
                    {id:"6",peopleId:"自己",chooses:[{chat:"多谢包工头",param:{"WeChatLink":"17"}}]},      
                ]
            },
            "5006": {//后续有1天没有来过招工工地
                people: "包工头",
                chats: [
                    {id:"0",peopleId:"包工头",chooses:[{chat:"小伙子，最近是不是发财了，都不来了",param:{"nextId":1}}]},
                    {id:"1",peopleId:"包工头",chooses:[{chat:"发达了，记得常来看看我",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"我不会忘了您的恩情",param:{"nextId":3}}]},
                    {id:"3",peopleId:"包工头",chooses:[{chat:"哈哈，哪有什么恩情不恩情的，你是我见过最老实的人",param:{"nextId":4}}]},      
                    {id:"4",peopleId:"包工头",chooses:[{chat:"在我这里打工太屈才了，我看得出，你是一个有抱负的人",param:{"nextId":5}}]},  
                    {id:"5",peopleId:"自己",chooses:[{chat:"您过誉了",param:{}}]},      
                ]
            },
            "5007": {//第1次成功搬砖1次以后
                people: "原石老板",
                chats: [
                    {id:"0",peopleId:"原石老板",chooses:[{chat:"少侠，我这里又进了不少好原石",param:{"nextId":1}}]},
                    {id:"1",peopleId:"原石老板",chooses:[{chat:"要不要来看看",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"哦？又进了新货啦，有空就来",param:{"nextId":3}}]},
                    {id:"3",peopleId:"原石老板",chooses:[{chat:"难得少侠识货，这种好料都留给你",param:{"nextId":4}}]},      
                    {id:"4",peopleId:"自己",chooses:[{chat:"一言为定",param:{"WeChatLink":"18"}}]},      
                ]
            },
            "5008": {//有1日未到集市后
                people: "原石老板",
                chats: [
                    {id:"0",peopleId:"原石老板",chooses:[{chat:"少侠，最近原石开出好东西的概率有提升",param:{"nextId":1}}]},
                    {id:"1",peopleId:"原石老板",chooses:[{chat:"要不要来看看",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"行，改日来",param:{}}]},
                ]
            },
            "5009": {//购买府邸以后
                people: "招募官",
                chats: [
                    {id:"0",peopleId:"招募官",chooses:[{chat:"大人，小的有眼不识泰山，莫见怪",param:{"nextId":1}}]},
                    {id:"1",peopleId:"招募官",chooses:[{chat:"近日来了不少武将，特别能干",param:{"nextId":2}}]},
                    {id:"2",peopleId:"招募官",chooses:[{chat:"若丢失良将，可就屈才了，还需大人尽快到招兵处看看",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"你先留住人，我马上过来",param:{"nextId":4}}]},
                    {id:"4",peopleId:"招募官",chooses:[{chat:"是，大人",param:{"WeChatLink":"19"}}]},
                ]
            },
            "5010": {//购买府邸以后，且1日未没有募兵场
                people: "招募官",
                chats: [
                    {id:"0",peopleId:"招募官",chooses:[{chat:"恭喜大人，贺喜大人，近日到达幽州城的武将众多，大人可招募更多武将了",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"招人不用花钱的吗",param:{"nextId":2}}]},
                    {id:"2",peopleId:"招募官",chooses:[{chat:"这...那属下将他们驱离",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"不必了，我自有安排",param:{}}]},
                ]
            },

            "5011": {//招募曹仁后
                people: "曹仁",
                chats: [
                    {id:"0",peopleId:"曹仁",chooses:[{chat:"主公，在下请战驻守官渡城，城在人在，城亡人亡",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"我自由安排，无需请战",param:{"nextId":2}}]},
                    {id:"2",peopleId:"曹仁",chooses:[{chat:"是，主公，在下先行退下了",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"去吧",param:{}}]},
                ]
            },
            "5012": {//招募马超后
                people: "马超",
                chats: [
                    {id:"0",peopleId:"马超",chooses:[{chat:"主公，在下曾徐州六郡，对此地极为熟悉",param:{"nextId":1}}]},
                    {id:"1",peopleId:"马超",chooses:[{chat:"若主公能派在下驻守徐州，定会治理得妥当",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"不要自作主张",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"我自有安排",param:{}}]},
                ]
            },
            "5013": {//招募黄忠后
                people: "黄忠",
                chats: [
                    {id:"0",peopleId:"黄忠",chooses:[{chat:"哈哈哈",param:{"nextId":1}}]},
                    {id:"1",peopleId:"黄忠",chooses:[{chat:"今日终于遇到伯乐啦，高兴高兴呀",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"黄老将军为人正直，又深得百姓爱戴",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"得黄老将军支持，何惧丢城",param:{}}]},
                ]
            },
            "5014": {//招募马岱
                people: "马岱",
                chats: [
                    {id:"0",peopleId:"马岱",chooses:[{chat:"主公，北方战事吃紧，我有一侄子叫马超",param:{"nextId":1}}]},
                    {id:"1",peopleId:"马岱",chooses:[{chat:"若主公能获得我侄儿，定能称霸一方",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"你先休息，我会注意",param:{}}]},
                ]
            },
            "5015": {//招募魏延
                people: "魏延",
                chats: [
                    {id:"0",peopleId:"魏延",chooses:[{chat:"主公，在下别的不会，赚钱倒是会得很，不知道主公安排在下去何处",param:{"nextId":1}}]},
                    {id:"1",peopleId:"魏延",chooses:[{chat:"只要主公下令，再难的城池，我都替主公夺来",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"我自有安排",param:{}}]},
                ]
            },
            "5016": {//招募夏侯惇
                people: "夏侯惇",
                chats: [
                    {id:"0",peopleId:"夏侯惇",chooses:[{chat:"你很有眼光嘛，我夏侯惇只要有钱，哪里都稳如泰山",param:{"nextId":1}}]},
                    {id:"1",peopleId:"夏侯惇",chooses:[{chat:"不知道你要我驻守哪里，看看那里的钱多不多",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"好好干活，别一天钱钱钱的",param:{"nextId":3}}]},
                    {id:"3",peopleId:"夏侯惇",chooses:[{chat:"额...知道了",param:{}}]},
                ]
            },
            "5017": {//招募徐晃
                people: "徐晃",
                chats: [
                    {id:"0",peopleId:"徐晃",chooses:[{chat:"主公，在下擅长水战，曾经也是水师提督",param:{"nextId":1}}]},
                    {id:"1",peopleId:"徐晃",chooses:[{chat:"主公可否安排在下在水域作战",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"有合适的机会，我会安排你的",param:{"nextId":3}}]},
                    {id:"3",peopleId:"徐晃",chooses:[{chat:"谢主公",param:{}}]},
                ]
            },
            "5018": {//招募许褚
                people: "许褚",
                chats: [
                    {id:"0",peopleId:"许褚",chooses:[{chat:"主公，你让俺砍谁俺就砍谁",param:{"nextId":1}}]},
                    {id:"1",peopleId:"许褚",chooses:[{chat:"只要主公下令，我爹都照砍不误",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"...你不要这么暴躁",param:{"nextId":3}}]},
                    {id:"3",peopleId:"许褚",chooses:[{chat:"俺是个粗人，只要有酒喝酒行",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"骑马不喝酒，喝酒不骑马，你喝酒还怎么打战啊",param:{"nextId":5}}]},
                    {id:"5",peopleId:"许褚",chooses:[{chat:"那就不打战的时候喝",param:{}}]},
                ]
            },
            "5019": {//招募颜良
                people: "颜良",
                chats: [
                    {id:"0",peopleId:"颜良",chooses:[{chat:"在下颜良，身经百战，请主公安排",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"你喜欢驻守哪里呀",param:{"nextId":2}}]},
                    {id:"2",peopleId:"颜良",chooses:[{chat:"在下想驻守荆州，那里有我的仇人，我要一雪前耻",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"再说吧",param:{}}]},
                ]
            },
            "5020": {//招募赵云
                people: "赵云",
                chats: [
                    {id:"0",peopleId:"赵云",chooses:[{chat:"我乃常山赵子龙，青钢剑在手，10个吕布都不是我的对手",param:{"nextId":1}}]},
                    {id:"1",peopleId:"赵云",chooses:[{chat:"不知主公有什么安排",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"子龙，你先好好休息，会有硬战要打",param:{"nextId":3}}]},
                    {id:"3",peopleId:"赵云",chooses:[{chat:"得令",param:{}}]},
                ]
            },
            "5021": {//有进贡物品时
                people: "押运官",
                chats: [
                    {id:"0",peopleId:"押运官",chooses:[{chat:"主公，您所属的城池会根据约定进贡物品",param:{"nextId":1}}]},
                    {id:"1",peopleId:"押运官",chooses:[{chat:"到时查看城池时由属下为您清点，请主公查看",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"知道了，我一会看看",param:{}}]},
                ]
            },
            "5022": {//招募赵云
                people: "周瑜",
                chats: [
                    {id:"0",peopleId:"周瑜",chooses:[{chat:"曾经我可是任命东吴高危职业的大都督",param:{"nextId":1}}]},
                    {id:"1",peopleId:"周瑜",chooses:[{chat:"请主公三思，尽量不要安排大都督一职",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"难道你怕死了吗",param:{"nextId":3}}]},
                    {id:"3",peopleId:"周瑜",chooses:[{chat:"那倒不是，只是继我之后的大都督好像都死得快，难免有些晦气",param:{}}]},
                ]
            },
            "5023": {
                people: "武林盟主",
                chats: [
                    {id:"0",peopleId:"武林盟主",chooses:[{chat:"少侠，已经1天没看到你了，你什么来看看我",param:{"nextId":1}}]},
                    {id:"1",peopleId:"武林盟主",chooses:[{chat:"......女儿",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"......承蒙盟主厚爱，我定不会负您的好意",param:{"nextId":3}}]},
                    {id:"3",peopleId:"武林盟主",chooses:[{chat:"不急不急，慢慢来，我上次跟你说的事，你考虑得怎么样了",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"...忘了，麻烦盟主提醒一下",param:{"nextId":5}}]},
                    {id:"5",peopleId:"武林盟主",chooses:[{chat:"别盟主盟主的叫，咱们以后都是一家人",param:{"nextId":6}}]},
                    {id:"6",peopleId:"自己",chooses:[{chat:"好的，未来岳父，我会尽快来娶你女儿的",param:{"nextId":7}}]},
                    {id:"7",peopleId:"武林盟主",chooses:[{chat:"我上次跟你说得4枚令牌，你以获得其2，另外两枚，还得看你的机缘",param:{"nextId":8}}]},
                    {id:"8",peopleId:"武林盟主",chooses:[{chat:"不要忘了我",param:{"nextId":9}}]},
                    {id:"9",peopleId:"武林盟主",chooses:[{chat:"......跟你说过的话，千万不能落入坏人之手",param:{"nextId":10}}]},
                    {id:"10",peopleId:"自己",chooses:[{chat:"......我记住了，盟主",param:{"nextId":11}}]},
                    {id:"11",peopleId:"武林盟主",chooses:[{chat:"又叫盟主，咱们都快成一家人了",param:{"nextId":12}}]},
                    {id:"12",peopleId:"自己",chooses:[{chat:"......好的，未来岳父",param:{"nextId":13}}]},
                    {id:"13",peopleId:"武林盟主",chooses:[{chat:"你还有什么要跟我说的吗？",param:{"nextId":14}}]},
                    {id:"14",peopleId:"自己",chooses:[{chat:"请未来岳父大人，说话不要大喘气",param:{"nextId":15}}]},
                    {id:"15",peopleId:"武林盟主",chooses:[{chat:"好的",param:{}}]},
                ]
            },
            "5024": {
                people: "武林盟主",
                chats: [
                    {id:"0",peopleId:"武林盟主",chooses:[{chat:"已经3天了，你凑齐了没，过时不候",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"我正在凑，请盟主放心",param:{"nextId":2}}]},
                    {id:"2",peopleId:"武林盟主",chooses:[{chat:"小女等得有些急不可耐，你还需快些才好",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"在下知道了",param:{}}]},
                 ]
            },
            "5025": {
                people: "武林盟主",
                chats: [
                    {id:"0",peopleId:"武林盟主",chooses:[{chat:"已经4天了，你凑齐了没",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"已经快了，请盟主放心",param:{"nextId":2}}]},
                    {id:"2",peopleId:"武林盟主",chooses:[{chat:"不要怪我没有提醒，过时不候",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"在下明白",param:{}}]},
                 ]
            },
            "5026": {
                people: "武林盟主",
                chats: [
                    {id:"0",peopleId:"武林盟主",chooses:[{chat:"都5天了，还没凑齐吗？",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"快了快了，就差一点点了，已经在加急了",param:{"nextId":2}}]},
                    {id:"2",peopleId:"武林盟主",chooses:[{chat:"这点小事都这么墨迹",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"让您操心了",param:{}}]},
                 ]
            },
            "5027": {
                people: "武林盟主",
                chats: [
                    {id:"0",peopleId:"武林盟主",chooses:[{chat:"明天就是最后1天了，你到底是不是诚心娶我女儿啊",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"在下是诚心娶小女的，还请盟主放心",param:{"nextId":2}}]},
                    {id:"2",peopleId:"武林盟主",chooses:[{chat:"如果明天还没有的话，你就不用再来了",param:{}}]},
                 ]
            },
            "5028": {
                people: "武林盟主",
                chats: [
                    {id:"0",peopleId:"武林盟主",chooses:[{chat:"今天是最后一天了，今天没有就当之前的事情作废",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"我今日会带上彩礼前来",param:{"nextId":2}}]},
                    {id:"2",peopleId:"武林盟主",chooses:[{chat:"小女在等你，不要让她失望",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"在下知道了",param:{}}]},
                 ]
            },
            "5029": {
                people: "武林盟主",
                chats: [
                    {id:"0",peopleId:"武林盟主",chooses:[{chat:"过得怎么样，我女儿还好吧",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"挺好的，岳父大人有心了",param:{"nextId":2}}]},
                    {id:"2",peopleId:"武林盟主",chooses:[{chat:"这是回礼，你收一下",param:{"nextId":3}}]},
                    {id:"3",peopleId:"武林盟主",chooses:[{chat:" ",param:{goods: [{coin:1000000000}, {id: 50012, count: 2}],recvGoodsAd: true,"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"多谢岳父大人",param:{}}]},
                 ]
            },
            "5030": {
                people: "公公",
                chats: [
                    {id:"0",peopleId:"公公",chooses:[{chat:"你就是那个救了贵妃娘娘的少年吧",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"公公有礼了，不知道有什么事",param:{"nextId":2}}]},
                    {id:"2",peopleId:"公公",chooses:[{chat:"我自然是为了给你送东西来的呀",param:{"nextId":3}}]},
                    {id:"3",peopleId:"公公",chooses:[{chat:"奉天承运，皇帝诏曰，少年救驾有功，特封幽州协律郎，官拜九品，钦此~",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"谢皇上隆恩",param:{"nextId":5}}]},
                    {id:"5",peopleId:"公公",chooses:[{chat:"这里没人就不用那么客气了，赶紧接旨吧",param:{"nextId":6}}]},
                    {id:"6",peopleId:"公公",chooses:[{chat:" ",param:{goods: [{id: 50017, count: 1,prestige:100}],recvGoodsAd: true,"nextId":7}}]},
                    {id:"7",peopleId:"自己",chooses:[{chat:"公公辛苦了",param:{"WeChatLink":"42"}}]},
                 ]
            },
            "5031": {
                people: "华贵妃",
                chats: [
                    {id:"0",peopleId:"华贵妃",chooses:[{chat:"按时间算，你也应该收到赏赐了",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"谢娘娘",param:{"nextId":2}}]},
                    {id:"2",peopleId:"华贵妃",chooses:[{chat:"不必客气，本宫赏罚分明，若日后你能进宫了，可到树林深处来找本宫",param:{"nextId":3}}]},
                    {id:"3",peopleId:"华贵妃",chooses:[{chat:"可惜了，上次事发后，皇上便不准本宫再外出打猎",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"皇上也是担心娘娘安危",param:{"nextId":5}}]},
                    {id:"5",peopleId:"华贵妃",chooses:[{chat:"你再替本宫办件事",param:{"nextId":6}}]},
                    {id:"6",peopleId:"自己",chooses:[{chat:"娘娘请吩咐",param:{"nextId":7}}]},
                    {id:"7",peopleId:"华贵妃",chooses:[{chat:"本宫听说近日有一诗仙，名为李白，出现在附近",param:{"nextId":8}}]},
                    {id:"8",peopleId:"华贵妃",chooses:[{chat:"常喜欢在河边饮酒作诗，你若遇到，请他帮本宫赋诗一首",param:{"nextId":9}}]},
                    {id:"9",peopleId:"自己",chooses:[{chat:"在下明白",param:{"triggerTask":'9'}}]},
                 ]
            },
            "5032": {
                people: "华贵妃",
                chats: [
                    {id:"0",peopleId:"华贵妃",chooses:[{chat:"事情办得不错",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"谢娘娘夸赞",param:{"nextId":2}}]},
                    {id:"2",peopleId:"华贵妃",chooses:[{chat:"我会再向陛下请旨赏赐于你",param:{"nextId":3}}]},
                    {id:"3",peopleId:"华贵妃",chooses:[{chat:"以后你就替本宫在宫外办差，本宫不会亏待你的",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"谢娘娘信任，在下定当竭尽全力为娘娘办差",param:{"nextId":5}}]},
                    {id:"5",peopleId:"华贵妃",chooses:[{chat:"好好做，本宫看好你",param:{"WeChatLink":"45"}}]},

                 ]
            },
            "5033": {
                people: "公公",
                chats: [
                    {id:"0",peopleId:"公公",chooses:[{chat:"你小子运气不错呀，娘娘又帮你请旨",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"走得狗屎运",param:{"nextId":2}}]},
                    {id:"2",peopleId:"公公",chooses:[{chat:"不要废话了，听旨吧~",param:{"nextId":3}}]},
                    {id:"3",peopleId:"公公",chooses:[{chat:"奉天承运，皇帝诏曰，少年屡立奇功，特封幽州巡抚，官拜八品，钦此",param:{"nextId":4}}]},
                    {id:"4",peopleId:"公公",chooses:[{chat:" ",param:{goods: [{id: 50017, count: 1,prestige:500}],recvGoodsAd: true,"nextId":5}}]},
                    {id:"5",peopleId:"自己",chooses:[{chat:"臣接旨，谢陛下隆恩",param:{"nextId":6}}]},
                    {id:"6",peopleId:"公公",chooses:[{chat:"自从你出现，娘娘都不安排活给杂家了",param:{"nextId":7}}]},
                    {id:"7",peopleId:"公公",chooses:[{chat:"你到底有什么本事，让娘娘如此恩宠你",param:{"nextId":8}}]},
                    {id:"8",peopleId:"自己",chooses:[{chat:"在下就替娘娘办好了一件差事，这不还得劳烦公公帮忙嘛",param:{"nextId":9}}]},
                    {id:"9",peopleId:"自己",chooses:[{chat:"一点点心意，还望公公笑纳",param:{"nextId":10}}]},
                    {id:"10",peopleId:"自己",chooses:[{chat:"10000铜钱", param:{goods: [{coin:10000}], "nextId":11}}]},
                    {id:"11",peopleId:"公公",chooses:[{chat:"哟~还挺会来事，那杂家就不客气啦",param:{addDelayEvent: {id: 16, delay: 1, finishDataType: 'delayType1'}, addRecordPoint: '5033Finish', "WeChatLink":"44"}}]},
                 ]
            },
            "5034": {
                people: "华贵妃",
                chats: [
                    {id:"0",peopleId:"华贵妃",chooses:[{chat:"你来河边树林深处，有一座小屋",param:{"nextId":1}}]},
                    {id:"1",peopleId:"华贵妃",chooses:[{chat:"若有人阻拦，你直接将我赐你的羊脂玉配给他",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"在下立刻前往",param:{"nextId":3}}]},
                    {id:"3",peopleId:"华贵妃",chooses:[{chat:"日后，你若有事可以直接前往，不会再有人阻拦",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"谢娘娘信任",param:{"triggerTask":'6',"WeChatLink":"46"}}]},
                ]
            },
            "5035": {
                people: "华贵妃",
                chats: [
                    {id:"0",peopleId:"华贵妃",chooses:[{chat:"河边新出现了一只押镖车队，你去探探虚实",param:{"nextId":1}}]},
                    {id:"1",peopleId:"华贵妃",chooses:[{chat:"听说在招募镖师，你身手不错，应该难不倒你",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"在下这就前往",param:{"nextId":3}}]},
                    {id:"3",peopleId:"华贵妃",chooses:[{chat:"切记，不可暴漏目的，若有问题立即汇报",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"那若没有问题，娘娘打算如何处理",param:{"nextId":5}}]},
                    {id:"5",peopleId:"华贵妃",chooses:[{chat:"无需多问，本宫自有安排",param:{"nextId":6}}]},       
                    {id:"6",peopleId:"华贵妃",chooses:[{chat:"本宫这段时间不会再回树林，有事会再给你飞鸽传书",param:{addRecordPoint: '5035Finish'}}]},
                ]
            },
            "5036": {
                people: "华贵妃",
                chats: [
                    {id:"0",peopleId:"华贵妃",chooses:[{chat:"去探过对方底啦？",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"禀娘娘，此押镖车队没有问题，在下已亲身体验",param:{"nextId":2}}]},
                    {id:"2",peopleId:"华贵妃",chooses:[{chat:"很好，本宫会安排公公在附近开辟一条新的押运路线",param:{"nextId":3}}]},
                    {id:"3",peopleId:"华贵妃",chooses:[{chat:"由你负责此路线安全，办好了本宫定重重有赏",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"谢娘娘，在下立刻前往",param:{addRecordPoint: '5036Finish'}}]},
                ]
            },
            "5037": {
                people: "华贵妃",
                chats: [
                    {id:"0",peopleId:"华贵妃",chooses:[{chat:"事情办得不错，本宫决定过几日将你引荐给皇上",param:{"nextId":1}}]},
                    {id:"1",peopleId:"华贵妃",chooses:[{chat:"日后替皇上办事，别丢了本宫得脸",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"多谢娘娘提拔",param:{"nextId":3}}]},
                    {id:"3",peopleId:"华贵妃",chooses:[{chat:"不必跟本宫客气，你也为本宫办了不少事了",param:{"nextId":4}}]},
                    {id:"4",peopleId:"华贵妃",chooses:[{chat:"这是你应得的",param:{"WeChatLink":["49", "50"]}}]},
                ]
            },
            "5038": {
                people: "神秘人",
                chats: [
                    {id:"0",peopleId:"神秘人",chooses:[{chat:"少侠，最近咋样呀，听说你娶了武林盟主的老婆",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"有话快说，怎么那么多事呢",param:{"nextId":2}}]},
                    {id:"2",peopleId:"神秘人",chooses:[{chat:"息怒息怒，我是来送最新情报的",param:{"nextId":3}}]},
                    {id:"3",peopleId:"神秘人",chooses:[{chat:"听说打猎能赚大钱啦，快去看看吧",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"我知道啦",param:{}}]},
                ]
            },
            "5039": {
                people: "华贵妃",
                chats: [
                    {id:"0",peopleId:"华贵妃",chooses:[{chat:"本宫已经将你推进给皇上",param:{"nextId":1}}]},
                    {id:"1",peopleId:"华贵妃",chooses:[{chat:"日后你凭借鎏金令可以直达皇宫享年殿",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"多谢娘娘厚爱",param:{"nextId":3}}]},
                    {id:"3",peopleId:"华贵妃",chooses:[{chat:"本宫与皇上近日已出宫，过些日子会招你入殿面圣",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"在下明白",param:{}}]},
                ]
            },
            "5040": {
                people: "神秘人",
                chats: [
                    {id:"0",peopleId:"神秘人",chooses:[{chat:"少侠，听说你最近有些烦心事",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"有话就说",param:{"nextId":2}}]},
                    {id:"2",peopleId:"神秘人",chooses:[{chat:"我知道你最近为了救老婆的事有点...",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"你知道什么快说",param:{"nextId":4}}]},
                    {id:"4",peopleId:"神秘人",chooses:[{chat:"我提供了这么多次情报，可是一点报酬都没有收到过",param:{"nextId":5}}]},
                    {id:"5",peopleId:"自己",chooses:[{chat:"甩出10万", param:{goods: [{coin:100000}], "nextId":6}}]},
                    {id:"6",peopleId:"自己",chooses:[{chat:"可以说了吧",param:{"nextId":7}}]},
                    {id:"7",peopleId:"神秘人",chooses:[{chat:"多谢少侠，情报说河边最近来了一群陌生人",param:{"nextId":8}}]},
                    {id:"8",peopleId:"神秘人",chooses:[{chat:"将树林深处的一座雅楼给霸占了，那里应该有你要找的人",param:{"nextId":9}}]},
                    {id:"9",peopleId:"自己",chooses:[{chat:"此事属实，另有打赏",param:{"nextId":10}}]},
                    {id:"10",peopleId:"神秘人",chooses:[{chat:"他们人数众多，少侠还是要谨慎行事呀",param:{"nextId":11}}]},
                    {id:"11",peopleId:"自己",chooses:[{chat:"你话比我爹还多",param:{addRecordPoint: '5040Finish'}}]},
                ]
            },
            "5041": {
                people: "武林盟主",
                chats: [
                    {id:"0",peopleId:"武林盟主",chooses:[{chat:"女婿，怎么没有回我消息",param:{"nextId":1}}]},
                    {id:"1",peopleId:"武林盟主",chooses:[{chat:"是我送的东西，你还没有研究明白吗",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"说来话长，最近家里发生了变故",param:{"nextId":3}}]},
                    {id:"3",peopleId:"自己",chooses:[{chat:"不知道如何跟岳父大人解释",param:{"nextId":4}}]},
                    {id:"4",peopleId:"武林盟主",chooses:[{chat:"发生了啥事呀",param:{"nextId":5}}]},
                    {id:"5",peopleId:"自己",chooses:[{chat:"清清被劫匪绑了", param:{"nextId":6}}]},
                    {id:"6",peopleId:"武林盟主",chooses:[{chat:"什么？谁绑的",param:{"nextId":7}}]},
                    {id:"7",peopleId:"自己",chooses:[{chat:"岳父大人别急，人我已经救回来了",param:{"nextId":8}}]},
                    {id:"8",peopleId:"自己",chooses:[{chat:"是一帮匪徒，身份还尚未可知",param:{"nextId":9}}]},
                    {id:"9",peopleId:"自己",chooses:[{chat:"说了一堆情况后...",param:{"nextId":10}}]},
                    {id:"10",peopleId:"武林盟主",chooses:[{chat:"我知道了，你以后少在外面惹事，我女儿可是我的掌上明珠啊",param:{"nextId":11}}]},
                    {id:"11",peopleId:"自己",chooses:[{chat:"岳父大人放心，再也不会有这样的事情发生",param:{"nextId":12}}]},
                    {id:"12",peopleId:"武林盟主",chooses:[{chat:"我信你个鬼，都已经发生过了",param:{"nextId":13}}]},
                    {id:"13",peopleId:"武林盟主",chooses:[{chat:"算了，你过段时间带清清去看看她奶奶吧",param:{"nextId":14}}]},
                    {id:"13",peopleId:"武林盟主",chooses:[{chat:"别怪我没警告你，再有这样的事，看我怎么收拾你",param:{addRecordPoint: '5041Finish'}}]},
                ]
            },
            "5042": {
                people: "管家",
                chats: [
                    {id:"0",peopleId:"管家",chooses:[{chat:"老爷，府邸开销已经入不敷出啦，还请老爷想想办法吧",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"我知道了",param:{}}]},
                ]
            },
            "5043": {
                people: "神秘人",
                chats: [
                    {id:"0",peopleId:"神秘人",chooses:[{chat:"少侠，我有重要情报",param:{"nextId":1}}]},
                    {id:"1",peopleId:"自己",chooses:[{chat:"你一出现准没好事，快说啥情况",param:{"nextId":2}}]},
                    {id:"2",peopleId:"神秘人",chooses:[{chat:"我占卜卦象显示，近日将有人集齐崆峒镜召唤穿越时空的能力",param:{"nextId":3}}]},
                    {id:"3",peopleId:"神秘人",chooses:[{chat:"在下得知少侠你已集齐不少碎片，始终缺少其中一块",param:{"nextId":4}}]},
                    {id:"4",peopleId:"自己",chooses:[{chat:"最后一块在哪",param:{"nextId":5}}]},
                    {id:"5",peopleId:"神秘人",chooses:[{chat:"少侠，这情报是需要花费一些精力的，不能白嫖呀",param:{"nextId":6}}]},
                    {id:"6",peopleId:"自己",chooses:[{chat:"甩出100万", param:{goods: [{coin:1000000}], "nextId":7}}]},
                    {id:"7",peopleId:"自己",chooses:[{chat:"能说了吗？",param:{"nextId":8}}]},
                    {id:"8",peopleId:"神秘人",chooses:[{chat:"少侠，这穿越时空的能力只值100万吗",param:{"nextId":9}}]},         
                    {id:"9",peopleId:"自己",chooses:[{chat:"我怎知情报是真是假",param:{"nextId":10}}]},
                    {id:"10",peopleId:"神秘人",chooses:[{chat:"那在下先替少侠记着这笔帐，这最后一块崆峒镜在一名老妇人手里",param:{"nextId":11}}]},     
                    {id:"11",peopleId:"神秘人",chooses:[{chat:"据说准备给自己的孙女做嫁妆，若你能娶得此女...",param:{"nextId":12}}]},     
                    {id:"12",peopleId:"自己",chooses:[{chat:"我知道了，你不用说了",param:{"WeChatLink":"55"}}]},
                ]
            },
            "5044": {
                people: "公公",
                chats: [        
                    {id:"0",peopleId:"公公",chooses:[{chat:"大人，昨日皇上已经回京了",param:{"nextId":1}}]},
                    {id:"1",peopleId:"公公",chooses:[{chat:"皇上召见大人速速进宫，用重要之事与大人密谈",param:{"nextId":2}}]},
                    {id:"2",peopleId:"自己",chooses:[{chat:"有劳公公，我立马进宫面圣",param:{"nextId":3}}]},
                ]
            },
            // "5022": {//第一次有城池丢失
            //     people: "幽州牧",
            //     chats: [
            //         {id:"0",peopleId:"幽州牧",chooses:[{chat:"现在战事吃紧，好像又有城池丢了，你要不要去看看",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"我一会看看",param:{}}]},
            //     ]
            // },
            // "4008": {
            //     people: "城中商人",
            //     chats: [
            //         {id:"0",peopleId:"城中商人",chooses:[{chat:"小兄弟，你看什么时候有时间",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"城中商人",chooses:[{chat:"城东的铺子暂时缺一个掌柜，你看可好呀",param:{"nextId":2}}]},
            //         {id:"2",peopleId:"自己",chooses:[{chat:"多谢兄台，那我现在是不是可以去铺子上任",param:{"nextId":3}}]},
            //         {id:"3",peopleId:"城中商人",chooses:[{chat:"小兄弟，别着急呀，那间铺子的老掌柜对铺子有了感情",param:{"nextId":4}}]},
            //         {id:"4",peopleId:"城中商人",chooses:[{chat:"你这样直接去上任，人家哪能呀",param:{"nextId":5}}]},
            //         {id:"5",peopleId:"城中商人",chooses:[{chat:"这老掌柜呢喜欢一些青花瓷，你看这...",param:{"nextId":6}}]},
            //         {id:"6",peopleId:"自己",chooses:[{chat:"在下明白，这就去送过去",param:{"nextId":7}}]},
            //         {id:"7",peopleId:"城中商人",chooses:[{chat:"那倒不用，我这刚好收了个青花瓷，只不过收来也花了些钱呀",param:{"nextId":8}}]},
            //         {id:"8",peopleId:"自己",chooses:[{chat:"滚，你这个无耻的骗子",param:{"nextId":9}},{chat:"明白，这些够不够买下您手里的这个",param:{"nextId":10}}]},
            //         {id:"9",peopleId:"城中商人",chooses:[{chat:"你你你...好心当成驴肝肺",param:{"WeChatLink":"9"}}]},
            //         {id:"10",peopleId:"自己",chooses:[{chat:"提供500文铜钱",param:{goods: [{coin:500}],"nextId":11}}]},
            //         {id:"11",peopleId:"城中商人",chooses:[{chat:"还是你懂事，我这就替你送过去，你再等等",param:{"WeChatLink":"10"}}]},
            //     ]
            // },
            // "4005": {
            //     people: "城中商人",
            //     chats: [
            //         {id:"0",peopleId:"城中商人",chooses:[{chat:"小兄弟，我收到来信说你需要帮助，你是想要一份工作是吧",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"是江南好友的朋友吧",param:{"nextId":2}}]},
            //         {id:"2",peopleId:"自己",chooses:[{chat:"在下现如今的确需要一个高收入的差事。",param:{"nextId":3}}]},
            //         {id:"3",peopleId:"城中商人",chooses:[{chat:"你这个好说，我附近商铺不少，可以安排你当个掌柜",param:{"nextId":4}}]},
            //         {id:"4",peopleId:"城中商人",chooses:[{chat:"只不过...空降一个掌柜难以服众呀，恐怕需要打点一下。",param:{"nextId":5}}]},
            //         {id:"5",peopleId:"自己",chooses:[{chat:"理应如此，小小意思不成敬意，有劳了",param:{"nextId":6}}]},
            //         {id:"6",peopleId:"自己",chooses:[{chat:"提供打点钱财",param:{goods: [{coin:200}],"nextId":7}}]},
            //         {id:"7",peopleId:"城中商人",chooses:[{chat:"这位小兄弟果然上道，一点就通，将来前途不可限量啊",param:{"nextId":8}}]},
            //         {id:"8",peopleId:"城中商人",chooses:[{chat:"小兄弟等我消息",param:{"WeChatLink":"8"}}]},
            //         {id:"9",peopleId:"神秘人",chooses:[{chat:" ",param:{"nextId":10,goods: [{id: 30005, count: 1}],}}]},
            //     ]
            // },
            // "4013": {
            //     people: "江南好友",
            //     chats: [

            //         {id:"0",peopleId:"江南好友",chooses:[{chat:"我算了算，也有些时日没同你联系了，不知兄弟在那边一切安好？我已再次命人替你物色合适的差事了。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"知道你有这份心意就足够了，事在人为，兄弟不必勉强，你的恩情我会记在心里的！",param:{"WeChatLink":"14"}}]},
                
            //     ]
            // },

            // "4014": {
            //     people: "差事",
            //     chats: [

            //         {id:"0",peopleId:"差事",chooses:[{chat:"阁下，大庆商行现特招东南地区缅北城常驻商行人员，差事轻松酬劳丰厚，日入千文不是梦，该差事仅招一位常驻人员，速联系。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"滚，你们这帮噶腰子的混账",param:{"WeChatLink":"15"}},{chat:"我有意愿前往缅北城！",param:{"result":false,}}]},
                
            //     ]
            // },

            // "4015": {
            //     people: "母妃",
            //     chats: [

            //         {id:"0",peopleId:"母妃",chooses:[{chat:"皇儿，宫中的日子不就是那般，还能有什么新鲜呢，母妃在这里一切都好，你要好好的，勿念。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"是，母妃，我一定会出人头地，将你风风光光的迎出冷宫的！",param:{"WeChatLink":"16"}}]},
                
            //     ]
            // },

            // "4016": {
            //     people: "幽州巡抚",
            //     chats: [

            //         {id:"0",peopleId:"幽州巡抚",chooses:[{chat:"阁下，我听下人说最近城里来了你这个新面孔，幽州城素来平静，望你来后老实本分，如果想要作妖，我会第一时间将你逐出城外的，你好自为之罢。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"在下明白...巡抚大人！",param:{"WeChatLink":"17"}}]},
                
            //     ]
            // },

            // "4017": {
            //     people: "波斯使团",
            //     chats: [

            //         {id:"0",peopleId:"波斯使团",chooses:[{chat:"阁下，听闻阁下从京城远道而来，想知道能否和阁下面谈，我想让我们波斯帝国与贵国多一些交流来往，幽州城便是起点，我见阁下气貌非凡，如果有阁下的帮助，想必我能事半功倍。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"我这段日子抽不开身，等挑个日子在城中酒楼与阁下小酌几杯！",param:{"WeChatLink":"18"}}]},
                
            //     ]
            // },

            // "4018": {
            //     people: "江南好友",
            //     chats: [

            //         {id:"0",peopleId:"江南好友",chooses:[{chat:"兄台，自从上次和你联系过后，我一直在替你寻一份好差事，现在有着落了，我一位在幽州城的朋友有差事可以提供给你，他会联系你的。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"你对我的恩情我将来必定十倍百倍报答回来！",param:{"WeChatLink":"19"}}]},
                
            //     ]
            // },

            // "4019": {
            //     people: "幽州巡抚",
            //     chats: [

            //         {id:"0",peopleId:"幽州巡抚",chooses:[{chat:"阁下，这几天本官应命在城中搜寻一位身份特殊的女子，你恰好早几日才来我幽州城，本官问你是否与此事有关联？让本官知道你撒谎了小心你的脑袋。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"启禀大人，小人...不知大人所言何事",param:{"nextId":2}},{chat:"我就算知道又如何？你休想知道半点线索",param:{"nextId":3}}]},
            //         {id:"2",peopleId:"幽州巡抚",chooses:[{chat:"哼，你最好所言非虚。",param:{"WeChatLink":"20"}}]},
            //         {id:"3",peopleId:"幽州巡抚",chooses:[{chat:"好大的胆子，竟敢在本官面前口出狂言，来人啊，将此人给我拿下。",param:{"result":false,}}]},
                
            //     ]
            // },
            
            // "4020": {
            //     people: "母妃",
            //     chats: [

            //         {id:"0",peopleId:"母妃",chooses:[{chat:"好，知道皇儿有这份心意，做母亲的就是马上离开这人世间也值了，唯一的遗憾就是你那皇妹，你俩从小青梅竹马一起长大，哎。。。也不知道她现在在幽州城怎么样，你和她都要好好的。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"没事...我和皇妹现在都很安全，母妃不用担心。（我不该让母妃担心的，她本就身子虚弱...眼下还是要先想办法把皇妹救走，不能再拖了！）",param:{"WeChatLink":"21"}}]},
                
            //     ]
            // },

            // "4021": {
            //     people: "波斯使团",
            //     chats: [

            //         {id:"0",peopleId:"波斯使团",chooses:[{chat:"阁下，请问午时在城南的酒楼议事如何呢？",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"好，到时候见。",param:{"WeChatLink":"22"}}]},
                
            //     ]
            // },

            // "4022": {
            //     people: "私盐贩子",
            //     chats: [

            //         {id:"0",peopleId:"私盐贩子",chooses:[{chat:"有人托我助你，我这买卖报酬不菲，不过须得将脑袋系腰间，想清楚给我答复。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"我考虑清楚了，富贵险中求",param:{"nextId":2}},{chat:"还是算了，这种买卖我干不了",param:{"isEnd":"对方将交谈内容销毁","WeChatLink":"23"}}]},
            //         {id:"2",peopleId:"私盐贩子",chooses:[{chat:"有胆量，这点小钱就当是提前赏你的，我会再联系你的，风紧扯呼！",param:{"nextId":3}}]},
            //         {id:"3",peopleId:"私盐贩子",chooses:[{chat:" ",param:{goods: [{coin:1000}],"WeChatLink":"23"}}]},
                
            //     ]
            // },

            // "4023": {
            //     people: "江南好友",
            //     chats: [

            //         {id:"0",peopleId:"江南好友",chooses:[{chat:"怎么样，这次我托人给你物色的差事靠谱吧？",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"靠谱？你给我找的可是贩卖私盐啊，把脑袋绑腰上干的活计，不过我活的好好的呢，不用为我担心，希望我能早日不依靠这些旁门左道来拼搏，不管怎样，多谢了。",param:{"WeChatLink":"24"}}]},
                
            //     ]
            // },

            // "4024": {
            //     people: "邻居",
            //     chats: [

            //         {id:"0",peopleId:"邻居",chooses:[{chat:"方才你不在的时候，我在门口歇息，突然几匹马疾驰而来，下来了几位全身黑衣身形不凡的汉子，他们冲进你的院子后就听见你妹子呼叫的声音，我赶忙去找人来帮忙，可惜待我们赶到之时他们已经把你妹子带走了，我隐约听到为首的那个汉子说了句“把这丫头带到巡抚那去”。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"多谢告知。（该死的，我一定要尽快升到七品知府，这样才能将妹妹救下来）",param:{"WeChatLink":"25"}}]},
                
            //     ]
            // },

            // "4025": {
            //     people: "幽州巡抚",
            //     chats: [

            //         {id:"0",peopleId:"幽州巡抚",chooses:[{chat:"本官的直觉告诉本官这女子与你有莫大渊源，哼，现在这娇滴滴的美人在我手上，本官不管你到底是真不认识还是假不认识此女子，以后在城里见到本官记得绕道走，本官看你十分不顺眼。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"你...好，在下知道了。(待我他日官居七品之日就是你倒霉之时)",param:{"WeChatLink":"26"}}]},
                
            //     ]
            // },

            // "4026": {
            //     people: "老师",
            //     chats: [

            //         {id:"0",peopleId:"老师",chooses:[{chat:"殿下近日在幽州城可好？君子博学而日参省乎己，则知明而行无过矣， 希望殿下时刻谨记君子有所为有所不为。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"老师，我现虽被贬为庶民，但老师的教诲未敢忘记分毫，近日我身边徒增许多变故，实乃心力交瘁，不过老师托付的赈灾一事我时刻谨记心头，望老师一切安好，便是弟子的福气。",param:{"WeChatLink":"27"}}]},
                
            //     ]
            // },

            // "4027": {
            //     people: "神秘人",
            //     chats: [

            //         {id:"0",peopleId:"神秘人",chooses:[{chat:"殿下,我已获悉幽州巡抚看守汝妹的确切位置，随时可派人强攻进去带走她，殿下如何以为？",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"自己",chooses:[{chat:"甚好，那就拜托你们了，切记勿要伤到吾妹",param:{"nextId":2}},{chat:"不必，这帮混账带给我的耻辱和夺走吾妹的仇我要亲手偿还回去。",param:{"WeChatLink":"28"}}]},
            //         {id:"2",peopleId:"神秘人",chooses:[{chat:"殿下，大事不妙，我派出去的手下遭到埋伏险些全军覆没，混乱中竟还有另外一支神秘力量出手将她掳走，现在官府的人已经盯上你了。",param:{"result":false,}}]},
                
            //     ]
            // },

            // "4028": {
            //     people: "乞丐",
            //     chats: [

            //         {id:"0",peopleId:"乞丐",chooses:[{chat:"这位爷，有人托我传话给您。",param:{"nextId":1}}]},
            //         {id:"1",peopleId:"乞丐",chooses:[{chat:"皇兄，我现在很安全，这封口信是我费劲千方百计才托人送出的，我希望你一切都好，千万不要做傻事，妹妹一直以来都坚信哥哥就是那九天之上的龙，决计不会因为这一点打击而投降的，哥哥要以自己的仕途为重，只消闲暇时刻能想起我，我便心满意足了，勿念。",param:{"nextId":2}}]},
            //         {id:"2",peopleId:"自己",chooses:[{chat:"多谢这位老哥。（如若连身边的人都守护不了，那就算我他日坐拥江山又如何？我一定要将妹妹救出来）",param:{addDelayEvent: {id: 2, delay: 1}}}]},
                
            //     ]
            // },

            






        }


    }
    return weChatChitLink;
}

//@ts-ignore
export function getOneChitAryById(id:string){
return WeChatChitConfigs()[id];
}
